import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { UserService } from '../user.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  isLoading = false;
  isSubmitted = false;
  isError = '';
  constructor(private userService: UserService) { }

  ngOnInit() {
    this.userService.getAuthStatusListner().subscribe((response) => {
        this.isError = this.userService.getError();
        if(this.isError) {
          this.isLoading = false;
        }
    });
  }
  
  onLogin(form: NgForm) {
    this.isLoading = true;
    if(form.invalid) {
      this.isLoading = false;
      return;
    }
    //console.log(form);
    
    this.userService.login(form.value.email, form.value.password);
  }
}